module.exports = __webpack_public_path__ + "static/hero-7b7524bdb6dc77118040163c11df3609.jpg";